import type { RealtimeBinding } from '@/shared/api';
import { qk } from '@/shared/api';
import { lazyComponent, type OverlayDef } from '@/shared/lib';
import type { CreateItem } from '@/widgets/app-shell';

/** Thành phần lớp phủ nạp khi mở (chunk riêng; OverlayHost nạp trước lúc rảnh). */
const TaskModal = lazyComponent(() => import('@/widgets/task-modal'), (x) => x.TaskModal, 'TaskModal');

/** Mục "Tạo mới" của module ở thanh trên (lọc theo module bật + quyền): mở lớp phủ lịch hẹn tại trang hiện tại. */
export const createItems: CreateItem[] = [{ label: 'Lịch hẹn', icon: 'calendar', module: 'schedule', perm: 'tasks.view', to: '.', overlay: ['task', 'new'] }];

/** ?task=new|<taskId> (&taskCustomer=<customerId> gắn sẵn khách) — mở từ mọi trang khi module schedule hiển thị. */
export const overlays: OverlayDef[] = [{ key: 'task', module: 'schedule', companions: ['taskCustomer'], layer: 'modal', component: TaskModal }];

/**
 * crm.tasks: lịch của tôi đổi (tạo/sửa/hoàn thành/xoá/bàn giao — gửi tới người thực hiện); crm.customers: khách đổi tên,
 * đổi chủ, bàn giao (phát cho mọi người) ⇒ tên khách và lịch của cả đội trên danh sách.
 */
export const realtime: RealtimeBinding[] = [
  { topic: 'crm.tasks', module: 'schedule', keys: () => [qk.tasks.all] },
  { topic: 'crm.customers', module: 'schedule', keys: () => [qk.tasks.all] },
];
